var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},_vm._l((_vm.products),function(product){return _c('div',{key:product.id,staticClass:"col-md-6 col-xl-4 col-sm-6 mb-4"},[_c('ProductCard',{attrs:{"product":product,"selected":_vm.isSelected(product.id)},on:{"toggle":_vm.onToggle}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }